import { render, staticRenderFns } from "./OverviewImage.vue?vue&type=template&id=7c0adf0a&scoped=true"
import script from "./OverviewImage.vue?vue&type=script&lang=js"
export * from "./OverviewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0adf0a",
  null
  
)

export default component.exports